import React from "react";

// components
import AttributionDisplayText from "core/AttributionDisplayText";

// graphql
import { PhotoDownloadType, UploadLicense } from "js/graphql";

import { PHOTO_DETAIL } from "data/links";

/*---------------------------
| Purchase Type
---------------------------*/
// purchase type keys
const purchaseTypeKeys = {
    public: "PUBLIC",
    basic: "BASIC",
    standard: "STANDARD_PHOTO",
    premium: "PREMIUM_PHOTO"
};

const purchaseTypes = [
    {
        id: 1,
        key: purchaseTypeKeys.public,
        name: "Public Domain (Free)",
        resolution: PhotoDownloadType.Public
    },
    {
        id: 2,
        key: purchaseTypeKeys.basic,
        name: "Basic (Free)",
        resolution: PhotoDownloadType.Basic
    },
    {
        id: 3,
        key: purchaseTypeKeys.standard,
        name: "Standard Photo",
        resolution: PhotoDownloadType.Standard
    },
    {
        id: 4,
        key: purchaseTypeKeys.premium,
        name: "Premium Photo",
        resolution: PhotoDownloadType.Premium
    }
];

const getPurchaseTypeByResolution = resolution => {
    return purchaseTypes.find(pt => pt.key === resolution);
};
const getPurchaseTypeByKey = key => {
    return purchaseTypes.find(pt => pt.key === key);
};

const getDefaultPurchaseTypeByAsset = asset => {
    return asset.license === UploadLicense.Creativecommons
        ? getPurchaseTypeByKey(
              asset.isPremium
                  ? purchaseTypeKeys.premium
                  : purchaseTypeKeys.standard
          )
        : getPurchaseTypeByKey(purchaseTypeKeys.public);
};
/*---------------------------
| Download Resource Params
    This is used for the data mapping keys used to tap BE for download resource
---------------------------*/
const getDownloadResourceParams = purchaseType => {
    let downloadResourceParams = {
        resolution: purchaseType.resolution,
        type: "jpg"
    };

    return downloadResourceParams;
};

/*---------------------------
| Attribution
---------------------------*/
const atrributionRequiredCheck = purchaseType => {
    return purchaseType.key === purchaseTypeKeys.basic;
};

const getHtmlAttrUrl = slugWithId => {
    const photoDetailEndpoint = PHOTO_DETAIL.replace(
        ":photoSlugWithId",
        slugWithId
    );
    return `https://thenounproject.com${photoDetailEndpoint}`;
};

const getHtmlAttrAnchorTitle = assetTitle => {
    return `${assetTitle} Photo`;
};

// getHtmlAttribution must return string and jsx versions for clipboard and display
export const getHtmlAttribution = (asset, purchaseType, darkMode = false) => {
    const license =
        purchaseType.key === purchaseTypeKeys.basic
            ? "CC BY-NC-ND 2.0"
            : "Royalty-Free Commercial License";

    const attrObj = {
        assetTitle: asset.title,
        creatorName: asset.creator.name,
        url: getHtmlAttrUrl(asset.slugWithId),
        anchorTitle: getHtmlAttrAnchorTitle(asset.title),
        darkMode: darkMode,
        license
    };

    return {
        string: `${attrObj.assetTitle} by ${attrObj.creatorName} from <a href="${attrObj.url}" target="_blank" title="${attrObj.anchorTitle}">Noun Project</a> (${attrObj.license})`,
        jsx: () => <AttributionDisplayText {...attrObj} />
    };
};

const attributionButtonText = {
    copied: "Copied",
    desktop: "Copy Link",
    modal: "Copy"
};

/*---------------------------
| Misc
---------------------------*/
const getThisAssetButtonText = `Get This Photo`;

const getPermalinkPath = asset => {
    return `/photo/${asset.slugWithId}/`;
};

export const assetDownloadConfig = {
    // Purchase Type
    purchaseTypeKeys,
    purchaseTypes,
    getPurchaseTypeByResolution,
    getPurchaseTypeByKey,
    getDefaultPurchaseTypeByAsset,

    // Download Resource Params
    getDownloadResourceParams,

    // Attribution
    atrributionRequiredCheck,
    getHtmlAttribution,
    attributionButtonText,

    // Misc
    getThisAssetButtonText,
    getPermalinkPath
};
